import "./InfoCard.scss";
const InfoCard = ({ image, title, description, buttonText, onClick }) => {
  return (
    <div className="info-card">
      <div className="info-card__image">
        <img src={image} alt={title} />
      </div>

      <div className="info-card__content">
        <h3 className="info-card__title">{title}</h3>
        <p className="info-card__description">{description}</p>

        <button className="info-card__button" onClick={onClick}>
          {buttonText}
        </button>
      </div>
    </div>
  );
};

export default InfoCard;
